import { render, staticRenderFns } from "./BulkEdit.vue?vue&type=template&id=162bc491&"
import script from "./BulkEdit.vue?vue&type=script&lang=ts&"
export * from "./BulkEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports